//rest URLs
//export const BASED_URL = '/ords/permitplus';
export const BASED_URL = '/ords/permitplus/myparkpal';
//export const BASED_URL = 'https://app-test.myparkpal.gr/ords/permitplus';
//export const BASED_URL = 'https://app-acc.myparkpal.gr/ords/permitplus';
//export const BASED_URL = 'https://app.myparkpal.gr/ords/permitplus';
//export const BASED_URL = 'https://intranet.desyde.nl/ords/permitplus';

//REGISTRATION
export const REGISTRATION_URL = BASED_URL + '/register';
export const ACTIVATION_URL = BASED_URL + '/activateAccount';
export const LOGIN_URL = BASED_URL + '/loginByPhoneNrAndEmail';
export const BALANCE_ACCOUNT_URL = BASED_URL + '/getBalance';
export const LICANSE_PLATE_URL = BASED_URL + '/getLicensePlate';
export const SETTINGS_URL = BASED_URL + '/loadSettings';
export const SAVE_SETTINGS_URL2 = BASED_URL + '/saveSettings';
export const SAVE_SETTINGS_URL = BASED_URL + '/saveSettings';

// PREPAID_CARD
export const PREPAID_CARD_URL = BASED_URL + '/updateBalanceByPrepaidCard';


// CREDIT_CARD
export const UPDATE_BALANCE_TOPUPEWALLET = BASED_URL + '/topUpEwallet';
export const GET_PAYMENT_STATUS = BASED_URL + '/getPaymentStatus';
export const GET_PAYMENT_FORM = BASED_URL + '/getPaymentForm';

// HISTORY
export const GET_HISTORY = BASED_URL + '/getAccountActions';
export const SEND_HISTORY = BASED_URL + '/sendAccountActionsToEmail';



// WEBPACK FOOTER //
// ./src/constants/restURLs.js